/**
 * Session cache for per-topic live briefs (content-first redesign).
 *
 * A single-topic brief is an EXPENSIVE live LLM analysis (18–45s, paid), so the
 * result is cached per topic for the session and shared across surfaces: the
 * briefing shows the diagnosis chip on the collapsed row after first expand, and
 * the map draws a diagnosis ring on the same topic — without ever re-firing the
 * call. A new radar run invalidates everything (the brief was computed from the
 * signal set at ITS fetch time — pairing it with fresh rows would be the silent
 * staleness the isStale nudge exists to prevent). Never batched: the only writer
 * is the briefing's one-at-a-time expand.
 */
import type { OpportunityBrief } from "@regpulse/contracts";

const cache = new Map<string, OpportunityBrief>();

export function getCachedBrief(topicId: string): OpportunityBrief | undefined {
  return cache.get(topicId);
}

export function setCachedBrief(topicId: string, brief: OpportunityBrief): void {
  cache.set(topicId, brief);
}

/** Topics with a session-cached brief (the map's diagnosis rings). */
export function cachedBriefTopicIds(): string[] {
  return [...cache.keys()];
}

/** Invalidate on every new radar run. */
export function invalidateBriefCache(): void {
  cache.clear();
}
